import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Table } from "antd";
import TableTop from "Components/UI/TableTop";
import { useTableSearch } from "core/Operations/useTableSearch";
import Error404 from "MainPages/ErrorPages/error404";
import { useForm, FormProvider } from "react-hook-form";
import { loggedInUser } from "core/redux/slice/authSlice";
import { useSelector } from "react-redux";
import { format } from "date-fns";
import Select from "react-select";
import { yupResolver } from "@hookform/resolvers/yup";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import {
  useAddDeductionMutation,
  useDeletePayrollDeductionMutation,
  useUpdateDeductionMutation,
} from "AppQuries/payroll/deduction/deduction";
import { Checkbox, Popconfirm, Switch } from "antd";
import ReportTools from "Components/UI/ReportTools";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
import { useGetBankPaymentListQuery } from "AppQuries/payroll/bank-file";
import MonthOption from "Components/Form/MonthSelect";
import YearOption from "Components/Form/YearSelect";
import { useFormattedDepartmentOption } from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import { bankFileValidation } from "../../core/Operations/ValidationSchema/payrollValidation";
import BankFile from "./payroll/BankFile";
import { useGetBanksQuery } from "AppQuries/master/Bank/bank";
import { downloadDBSBankCsvTemplate } from "./payroll/BankFile/BankFileTemplate";

const BankPaymentList = () => {
  const userData = useSelector(loggedInUser);
  const [queryParams, setQueryParams] = useState({
    month: format(new Date(), "MM"),
    year: format(new Date(), "yyyy"),
    departmentCode: 0,
  });

  const [isMount, setIsMount] = useState(false);
  const [showActiveOnly, setShowActiveOnly] = useState(true);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const departmentOptions = useFormattedDepartmentOption(userData?.companyCode);
  const { data: bankList } = useGetBanksQuery({
    companyCode: userData.companyCode,
    isTrue: true,
  });

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const methods = useForm({
    defaultValues: {
      payDate: format(new Date(), "yyyy-MM-dd"),
    },
    // resolver: yupResolver(bankFileValidation),
  });

  const [isBankFileModalVisible, setIsBankFileModalVisible] = useState(false);

  const showBankFileModal = () => {
    setIsBankFileModalVisible(true);
  };
  const handleBankFileCancel = () => setIsBankFileModalVisible(false);

  const {
    data,
    isLoading,
    isFetching,
    isError,
    error,
    refetch: getPaymentList,
  } = useGetBankPaymentListQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    userId: userData?.userID,
    isAllCompanies: userData?.isAllCompanies,
    selectedCompanyCode: userData?.selectedCompanyCode,
    ...queryParams,
  });

  const bankPaymentData = data?.map((item, key) => ({ ...item, key })) || [];

  const onSubmit = async (payload) => {
    console.log("Bank File Payload:", payload);

    const selectedEmployees = bankPaymentData.filter((item) =>
      selectedRowKeys.includes(item.key),
    );
    console.log("Selected Employees for Bank File:", selectedEmployees);
    downloadDBSBankCsvTemplate({
      date: format(new Date(payload?.payDate), "ddMMyyyy"),
      organisationId: payload.organisationId,
      organisationName: payload.organisationName,
      accountNumber: payload.accountNumber,
      employees: selectedEmployees,

      //   employees: selectedEmployees Array.from({ length: 10 }).map((_, i) => ({
      //     type: "M",
      //     value: `+65900000${i}`,
      //   })),
    });
  };

  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueID",
      key: "uniqueID",
    },
    {
      title: "Emp Name",
      dataIndex: "employeeName",
      key: "employeeName",
    },
    {
      title: "Month",
      dataIndex: "payrollMonth",
      key: "payrollMonth",
    },
    {
      title: "Year",
      dataIndex: "payrollYear",
      key: "payrollYear",
    },
    {
      title: "Paymode",
      dataIndex: "paymentMode",
      key: "paymentMode",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Bank Name",
      dataIndex: "bankName",
      key: "bankName",
    },
  ];

  const searchColumns = columns.map((column, index) => column.dataIndex);
  const { searchValue, setSearchValue, filteredData } = useTableSearch(
    bankPaymentData,
    searchColumns,
  );

  const toggleSelectAll = () => {
    setSelectedRowKeys((keys) =>
      keys.length === bankPaymentData.length
        ? []
        : bankPaymentData.map((r) => r.key),
    );
  };

  const handleSelect = (record, selected) => {
    if (selected) {
      setSelectedRowKeys((keys) => [...keys, record.key]);
    } else {
      setSelectedRowKeys((keys) => {
        const index = keys.indexOf(record.key);
        return [...keys.slice(0, index), ...keys.slice(index + 1)];
      });
    }
  };

  const headerCheckbox = (
    <Checkbox
      checked={
        selectedRowKeys.length === bankPaymentData.length &&
        bankPaymentData.length > 0
      }
      indeterminate={
        selectedRowKeys.length > 0 &&
        selectedRowKeys.length < bankPaymentData.length
      }
      style={{ zIndex: "unset" }}
      onChange={toggleSelectAll}
    />
  );

  const rowSelection = {
    selectedRowKeys,
    type: "checkbox",
    fixed: true,
    onSelect: handleSelect,
    columnTitle: headerCheckbox,
    onSelectAll: toggleSelectAll,
  };

  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };

  const filterComponents = (
    <div className="form-row row">
      <div className="row">
        <div className="col-lg-4 col-sm-6 col-12 mb-3">
          <div className="form-group">
            <label className="form-label">Department </label>

            <Select
              className="select"
              options={departmentOptions}
              placeholder="Department"
              value={departmentOptions.find(
                (option) => option.value === queryParams.departmentCode,
              )}
              onChange={(e) => {
                updateQueryParams("departmentCode", e?.value || 0);
              }}
              isClearable
              // menuPortalTarget={document.body}
              menuPosition="absolute"
              styles={{
                control: (baseStyles) => ({
                  ...baseStyles,
                  zIndex: 111,
                }),
                menuPortal: (baseStyles) => ({
                  ...baseStyles,
                  zIndex: 9999,
                }),
              }}
            />
          </div>
        </div>
        <div className="col-lg-3 col-sm-6 col-12 mb-3">
          <div className="form-group">
            <label className="form-label">Month</label>
            <MonthOption
              selectedMonth={queryParams.month}
              monthSelectHandler={(e) => {
                updateQueryParams("month", e);
              }}
            />
          </div>
        </div>
        <div className="col-lg-3 col-sm-6 col-12 mb-3">
          <div className="form-group">
            <label className="form-label">Year</label>
            <YearOption
              selectedYear={queryParams.year}
              yearSelectHandler={(value) => {
                updateQueryParams("year", value);
              }}
            />
          </div>
        </div>

        <div className="col-lg-2 col-sm-6 col-12">
          <div className="input-blocks">
            <label className="form-label">&nbsp;</label>
            <Link
              className="btn btn-filters ms-auto"
              onClick={getPaymentList}
              type="button"
            >
              <i data-feather="search" className="feather-search" />
              {isFetching ? (
                <>
                  <i className="fas fa-spinner fa-spin me-2"></i>
                  Loading...
                </>
              ) : (
                <>Filter</>
              )}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );

  if (isLoading || isFetching) return <LoadingSpinner />;
  if (isError) return <Error404 error={error} />;

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Bank Payment List</h4>
                <h6>Manage your Bank Payments</h6>
              </div>
            </div>
            <div className="page-btn">
              {/* <Can
                  accessModule={accessCodes.payroll_management}
                  accessCode={accessCodes.payroll_records}
                  accessType="haveEdit"
                > */}
              {/* <button
                to={`${all_routes.payroll}${all_routes.payroll_bank_file}`}

                className={
                  selectedRowKeys.length <= 0
                    ? "btn btn-default disabled"
                    : "btn btn-primary"
                }
                disabled={selectedRowKeys.length <= 0}
                onClick={showBankFileModal}
              >
                Generate Bank File
              </button> */}
              {/* </Can> */}
              &nbsp;
            </div>
            <div className="page-btn">
              <ReportTools
                columns={columns}
                data={filteredData}
                fileName="Bank Payment List"
                isExcel={true}
                isPdf={true}
                pdfTheme="striped"
                refresh={getPaymentList}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="card table-list-card border-0">
                <div className="card-body">
                  <TableTop
                    onSearch={setSearchValue}
                    toggleFilterVisibility={toggleFilterVisibility}
                    isFilterVisible={isFilterVisible}
                    showToggle={false}
                    otherProps={filterComponents}
                  />
                  <div
                    className={`card${isFilterVisible ? " visible" : ""}`}
                    id="filter_inputs"
                    // style={{ display: isFilterVisible ? "block" : "none" }}
                  >
                    <div className="card-body pb-0">
                      <div className="form-row row">
                        <div className="row">
                          <div className="col-lg-3 col-sm-6 col-12 mb-3">
                            <div className="form-group">
                              <Switch
                                checked={showActiveOnly}
                                checkedChildren="Show Active"
                                unCheckedChildren="Show All"
                                onChange={(checked) =>
                                  setShowActiveOnly(checked)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <Table
                      rowSelection={rowSelection}
                      className="table datanew"
                      columns={columns}
                      dataSource={filteredData}
                      Key={(record) => record.key}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FormProvider {...methods}>
        <BankFile
          bankList={bankList}
          userData={userData}
          show={isBankFileModalVisible}
          onSubmit={onSubmit}
          handleClose={handleBankFileCancel}
        />
      </FormProvider>
    </div>
  );
};

export default BankPaymentList;
